var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-page"},[_c('img',{attrs:{"src":require('@assets/ic_404.png'),"alt":""}}),_c('div',[_vm._v("正在建设中，敬请期待")])])}
var staticRenderFns = []

export { render, staticRenderFns }